import { PersonaConfig } from '../types';

export const generalPersona: PersonaConfig = {
  id: 'general',
  name: 'General Weather',
  icon: '🌤️',
  description: 'Standard comprehensive weather and environmental overlays.',
  accentColor: '#3b82f6',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'all',
    hideAstronomicalEvents: false,
    showMilkyWayArButton: false,
  },
  mapDefaults: {
    recommendedPrimaryLayer: undefined,
    enabledOverlays: [],
  },
};
